import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { traceButtonClass } from './cx.js';
import { GoogleIcon, KeyIcon, MailIcon, MicrosoftIcon } from './icons.js';
export function methodLabel(method) {
    switch (method.type) {
        case 'microsoft':
            return 'Continue with Microsoft';
        case 'google':
            return 'Continue with Google';
        case 'organization-sso':
            // The API sends complete, deliberately generic button text that never names the organization.
            return method.label;
        case 'passwordless-email':
            return 'Continue with email';
        case 'password':
            return 'Continue with email and password';
    }
}
function MethodIcon({ method }) {
    if (method.type === 'microsoft' || (method.type === 'organization-sso' && method.provider === 'microsoft')) {
        return _jsx(MicrosoftIcon, {});
    }
    if (method.type === 'google' || (method.type === 'organization-sso' && method.provider === 'google')) {
        return _jsx(GoogleIcon, {});
    }
    if (method.type === 'organization-sso')
        return _jsx(KeyIcon, {});
    return _jsx(MailIcon, {});
}
/**
 * Sign-in buttons for the configured identity-provider methods. Each button starts the provider sign-in
 * with its own connection (and organization for organization SSO). A development fixture can never be
 * passed here: fixtures are not login methods and live in DevIdentityPanel.
 */
export function SignInMethodList({ methods, beginSignIn, signInOptions, disabled = false, labelFor, onError, label = 'Sign-in options', }) {
    const [pending, setPending] = useState(null);
    if (methods.length === 0)
        return null;
    async function start(method, index) {
        if (disabled || pending !== null)
            return;
        setPending(index);
        try {
            await beginSignIn({
                ...signInOptions,
                connection: method.connection,
                ...(method.type === 'organization-sso' ? { organization: method.organizationRef } : {}),
            });
        }
        catch (error) {
            setPending(null);
            onError?.(error);
        }
    }
    return (_jsx("ul", { className: "trace-auth-methods", "aria-label": label, children: methods.map((method, index) => (_jsx("li", { children: _jsxs("button", { type: "button", className: traceButtonClass('quiet', { block: true }), onClick: () => void start(method, index), disabled: disabled || (pending !== null && pending !== index), "aria-busy": pending === index || undefined, "data-method": method.type, children: [_jsx(MethodIcon, { method: method }), _jsx("span", { children: labelFor?.(method) ?? methodLabel(method) })] }) }, `${method.type}:${method.connection}:${index}`))) }));
}
//# sourceMappingURL=SignInMethodList.js.map